<template>
  <div id="app">
    <Chat v-if="isChat"></Chat>
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import Chat from '@/components/Chat'
export default {
  name: 'App',
  components: {
    Chat
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      clientWidth: '',
      isRouterAlive: true,
      routerName: ['activityKv', 'activityShop', 'luckdraw', 'myLuckdraw'],
      isChat: true
    }
  },
  watch: {
    clientWidth (newValue, oldValue) {
      if (newValue > 768) {
        this.$store.commit('SET_ISPC', true)
      } else {
        this.$store.commit('SET_ISPC', false)
      }
    },
    '$route.path' (val) {
      window.scrollTo(0, 0)
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    window.scrollTo(0, 0)
    next()
  },
  mounted () {
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isChat = false
      }
    } catch (error) {}
    this.clientWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.clientWidth = document.body.clientWidth
      })()
    }
    let script = document.createElement('script') // 创建一个script标签
    script.type = 'text/javascript'
    script.src = 'https://www.crsc.philips.com/crsc/scripts/s_code_philipsglobal.js'
    document.body.appendChild(script)
  }
}
</script>

<style>
  * {
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue